/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* @flow */
export default {
  lime_10: '#f1fae6',
  lime_20: '#e7facf',
  lime_30: '#d2f7a8',
  lime_40: '#b5f07a',
  lime_50: '#9be650',
  lime_60: '#81d42f',
  lime_70: '#6cbf19',
  lime_80: '#5aa60d',
  lime_90: '#4a8c08',
  lime_100: '#3d7307',

  a11y_text_light: [100]
};



// WEBPACK FOOTER //
// ./src/colors/lime.js